export const TargetStationsFilterState = () => ({
  page: 1,
  perPage: 10,
  chargedTo: [],
  platformType: "plb",
});
